import React, { useState, useEffect } from 'react';
import { API_URL, getAccessToken, setAccessToken, clearAccessToken } from '../../utils/api';

function CustomerDashboard({ user }) {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const token = getAccessToken();
      const response = await fetch(`${API_URL}/customer/dashboard`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setDashboardData(data);
      }
    } catch (error) {
      console.error('Error fetching dashboard:', error);
    }
    setLoading(false);
  };

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div className="customer-dashboard">
      <div className="page-header">
        <h1>Welcome back, {user?.first_name}!</h1>
        <p className="subtitle">Here's an overview of your account</p>
      </div>

      <div className="dashboard-grid">
        <div className="metric-card">
          <div className="metric-header">
            <h3>Active Jobs</h3>
          </div>
          <p className="metric-value">{dashboardData?.activeJobs || 0}</p>
          <p className="metric-subtitle">In progress</p>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <h3>Vessels</h3>
          </div>
          <p className="metric-value">{dashboardData?.vesselCount || 0}</p>
          <p className="metric-subtitle">Registered</p>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <h3>Open Tickets</h3>
          </div>
          <p className="metric-value">{dashboardData?.openTickets || 0}</p>
          <p className="metric-subtitle">Support requests</p>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <h3>Membership</h3>
          </div>
          <p className="metric-value">{dashboardData?.membershipPlan || 'None'}</p>
          <p className="metric-subtitle">{dashboardData?.membershipStatus || 'Not subscribed'}</p>
        </div>
      </div>

      {dashboardData?.upcomingAppointments?.length > 0 && (
        <div className="card">
          <div className="card-header">
            <h3>Upcoming Appointments</h3>
          </div>
          <div className="card-content">
            {dashboardData.upcomingAppointments.map((apt, i) => (
              <div key={i} className="appointment-item">
                <span className="apt-date">{new Date(apt.date).toLocaleDateString()}</span>
                <span className="apt-title">{apt.title}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerDashboard;
